import Roles from "./Roles";


/**
 * Navigation Links for Staff roles in the system
 * Organized into logical groups with role-based access control
 */
const OfficerLinks = {
  management: [
    // Students & People Management
    {
      title: "Students",
      icon: "mdi-account-school",
      roles: [Roles.DepartmentOfficer, Roles.PgCoordinator, Roles.DeanSpgs, Roles.Hod, Roles.AcademicSecretary, Roles.DeanStudentAffair, Roles.SecurityOfficer, Roles.StudentManagement, Roles.StudentManagementAdministrative, Roles.PassportOfficer, Roles.StudentAffair],
      children: [
        { title: "Students", icon: "mdi-account-group", url: "students", roles: [Roles.DepartmentOfficer, Roles.PgCoordinator, Roles.DeanSpgs, Roles.Hod, Roles.AcademicSecretary, Roles.DeanStudentAffair] },
        { title: "Defenses", icon: "mdi-gavel", url: "defenses", roles: [Roles.DeanSpgs, Roles.Hod] },
        { title: "Student (Security)", icon: "mdi-shield-account", url: "mystudent", roles: [Roles.SecurityOfficer] },
        { title: "Students Management", icon: "mdi-account-cog", url: "student_management", roles: [Roles.StudentManagement, Roles.StudentManagementAdministrative, Roles.PassportOfficer] },
        { title: "Student ID Cards", icon: "mdi-card-account-details", url: "student_id_card", roles: [Roles.StudentAffair] },
        { title: "Data Correction", icon: "mdi-file-document-edit", url: "data_correction", roles: [Roles.DataCorrectionVerification] },
        { title: "Biometrics", icon: "mdi-fingerprint", url: "biometrics", roles: [Roles.BiometricOfficer] },
      ]
    },

    // Staff Management
    {
      title: "Staff",
      icon: "mdi-account-tie",
      roles: [Roles.Hod, Roles.PgCoordinator, Roles.StaffManagement, Roles.DeanSpgs],
      children: [
        { title: "Department Staff", icon: "mdi-account-supervisor", url: "lecturers", roles: [Roles.Hod, Roles.PgCoordinator] },
        { title: "External Examiners", icon: "mdi-account-check", url: "external_examiners", roles: [Roles.Hod] },
        { title: "Internal Examiners", icon: "mdi-account-star-outline", url: "internal_examiners", roles: [Roles.Hod, Roles.DeanSpgs] },
        { title: "Staff Management", icon: "mdi-account-group-outline", url: "staff_management", roles: [Roles.StaffManagement] },
      ]
    },

    // Academic - Courses & Teaching
    {
      title: "Academic",
      icon: "mdi-school",
      roles: [Roles.Lecturer, Roles.DAP, Roles.Hod, Roles.PgCoordinator, Roles.LevelAdviser, Roles.Dean, Roles.CBT],
      children: [
        { title: "My Courses", icon: "mdi-book-open-variant", url: "my_courses", roles: [Roles.Lecturer], academic: true },
        { title: "Results Entry", icon: "mdi-clipboard-edit", url: "results", roles: [Roles.Lecturer] },
        { title: "Courses", icon: "mdi-bookshelf", url: "courses", roles: [Roles.DAP, Roles.Hod, Roles.PgCoordinator] },
        { title: "CBT Courses", icon: "mdi-monitor-edit", url: "cbt_courses", roles: [Roles.Hod, Roles.CBT] },
        { title: "Registrations", icon: "mdi-clipboard-text-outline", url: "registration_management", roles: [Roles.Hod, Roles.PgCoordinator, Roles.LevelAdviser, Roles.Dean, Roles.DAP] },
        { title: "Questions Bank", icon: "mdi-help-circle-outline", url: "question", roles: [Roles.Lecturer] },
        { title: "TimeTable", icon: "mdi-calendar-clock", url: "timetable", roles: [Roles.LevelAdviser] },
      ]
    },

    // Results Processing
    {
      title: "Results Processing",
      icon: "mdi-chart-box",
      roles: [Roles.Hod, Roles.PgCoordinator, Roles.DepartmentOfficer, Roles.FacultyExamBoard, Roles.FacultyOfficer, Roles.Dean, Roles.SenateSubCommittee, Roles.DVCAcademics, Roles.HeadOfSenate, Roles.Senate, Roles.ResultAdmin],
      children: [
        { title: "Department Results", icon: "mdi-chevron-triple-down", url: "manage_results", roles: [Roles.Hod, Roles.PgCoordinator, Roles.DepartmentOfficer] },
        { title: "Faculty Results", icon: "mdi-chevron-triple-right", url: "manage_results_faculty", roles: [Roles.FacultyExamBoard, Roles.FacultyOfficer, Roles.Dean] },
        { title: "Sub Senate Results", icon: "mdi-chevron-triple-left", url: "manage_results_subsenate", roles: [Roles.SenateSubCommittee, Roles.DVCAcademics] },
        { title: "Senate Results", icon: "mdi-chevron-triple-up", url: "manage_results_senate", roles: [Roles.HeadOfSenate, Roles.Senate] },
        { title: "Result Admin", icon: "mdi-cog", url: "result_mgmt", roles: [Roles.ResultAdmin] },
        { title: "Result Uploads", icon: "mdi-file-find", url: "result_audit", roles: [Roles.ResultAdmin] },
      ]
    },

    // Curriculum Management
    {
      title: "Curriculum",
      icon: "mdi-book-education",
      roles: [Roles.Hod, Roles.PgCoordinator, Roles.ResultAdmin, Roles.Admin],
      children: [
        { title: "Curriculum Management", icon: "mdi-book-edit", url: "curriculum", roles: [Roles.Hod, Roles.ResultAdmin, Roles.Admin] },
        { title: "Department Curriculum", icon: "mdi-file-tree", url: "department_curriculum", roles: [Roles.ResultAdmin, Roles.Hod] },
        // { title: "Curriculum Mappings", icon: "mdi-calendar-sync", url: "curriculum_mappings", roles: [Roles.Hod, Roles.ResultAdmin, Roles.Admin] },
        // { title: "Curriculum Overrides", icon: "mdi-swap-horizontal", url: "curriculum_overrides", roles: [Roles.Hod, Roles.ResultAdmin, Roles.Admin] },
        { title: "Prerequisite Courses", icon: "mdi-link-variant", url: "prerequisites", roles: [Roles.Hod, Roles.PgCoordinator] },
      ]
    },

    // Admission & Applicants
    {
      title: "Admission",
      icon: "mdi-account-plus",
      roles: [Roles.AdmissionOfficer, Roles.Clearance, Roles.ScreeningVerificationOfficer, Roles.ApplicantManagement, Roles.SupportOfficer, Roles.StudentManagement, Roles.StudentManagementAdministrative, Roles.Bursar, Roles.ChangedOfProgrammeApplicant, Roles.Hod],
      children: [
        { title: "Admission", icon: "mdi-account-multiple-plus", url: "admission", roles: [Roles.AdmissionOfficer, Roles.Clearance, Roles.ScreeningVerificationOfficer, Roles.ApplicantManagement] },
        { title: "Applicants Support", icon: "mdi-account-question", url: "application-support", roles: [Roles.SupportOfficer, Roles.StudentManagement, Roles.StudentManagementAdministrative, Roles.Bursar] },
        { title: "Change Of Applicant", icon: "mdi-account-switch", url: "change_programme_applicants", roles: [Roles.ChangedOfProgrammeApplicant] },
        { title: "Change Of Programme", icon: "mdi-swap-horizontal-bold", url: "change_programme_students", roles: [Roles.Hod] },
      ]
    },

    // Clearance
    {
      title: "Clearance",
      icon: "mdi-check-decagram",
      url: "officer_clearance",
      roles: [Roles.Hod, Roles.ClearanceAdmin, Roles.ClearanceOfficial],
    },

    // Statement of Result pipeline
    {
      title: "Statement Dashboard",
      icon: "mdi-file-chart",
      url: "statement_dashboard",
      roles: [Roles.Registrar, Roles.SecretarySpgs, Roles.DeanSpgs, Roles.Admin],
    },

    // Finance
    {
      title: "Fees",
      icon: "mdi-cash-multiple",
      url: "school_fees",
      roles: [Roles.Bursar, Roles.StudentAccount, Roles.PaymentVerificationOfficer, Roles.StudentManagementAdministrative],
    },

    // Hostel
    {
      title: "Hostel",
      icon: "mdi-home-city",
      url: "hostel",
      roles: [Roles.HostelOfficer],
    },

    // Evaluations
    {
      title: "Evaluations",
      icon: "mdi-clipboard-check",
      url: "evaluation/evaluations",
      roles: [Roles.Supervisor, Roles.DeanSpgs, Roles.InternalExaminer, Roles.Reviewer, Roles.ExternalExaminer, Roles.Hod, Roles.Dean, Roles.DeanSpgs, Roles.SecretarySpgs],
    },

    // Transcript
    {
      title: "Transcript",
      icon: "mdi-certificate",
      url: "transcript_officer",
      roles: [Roles.TranscriptOfficer],
    },

    // Department Management
    {
      title: "Department",
      icon: "mdi-domain",
      roles: [Roles.Hod, Roles.PgCoordinator],
      children: [
        { title: "Department Settings", icon: "mdi-cog", url: "department_settings", roles: [Roles.Hod, Roles.PgCoordinator] },
        { title: "Level Advisers", icon: "mdi-account-star", url: "level_adviser", roles: [Roles.Hod] },
      ]
    },

    // Communication
    {
      title: "Communication",
      icon: "mdi-message-text",
      roles: [Roles.AnnouncementOfficer],
      children: [
        { title: "Notification", icon: "mdi-bell", url: "notification", roles: [] },
        { title: "Announcement", icon: "mdi-bullhorn", url: "announcement", roles: [Roles.AnnouncementOfficer] },
      ]
    },

    // Reports & Administration
    {
      title: "Reports",
      icon: "mdi-chart-bar",
      roles: [Roles.StatsOfficer, Roles.VC, Roles.DVCAcademics, Roles.DVCAdmin, Roles.Senate, Roles.HeadOfSenate],
      children: [
        { title: "Statistics", icon: "mdi-chart-line", url: "stats", roles: [Roles.StatsOfficer] },
        { title: "Audit Trails", icon: "mdi-history", url: "audit_trails", roles: [Roles.HeadOfSenate] },
      ]
    },
  ],

  settings: [
    { title: "Settings", icon: "mdi-cog", url: "settings" },
  ],
};



/**
 * Flattened { "/url": [roles] } map derived from OfficerLinks, used to guard
 * officer route access (e.g. against manual URL-bar edits). Entries with no
 * roles or an empty roles array are omitted — those routes stay unrestricted.
 */
const officerRouteRoles = (() => {
    const map = {};
    const add = (entry) => {
        if (entry.url && Array.isArray(entry.roles) && entry.roles.length > 0) {
            map["/" + entry.url] = entry.roles;
        }
    };
    OfficerLinks.management.forEach((item) => {
        add(item);
        (item.children || []).forEach(add);
    });
    return map;
})();


/**
 * Navigation Links for student
 */
const StudentLinks = {
    management: [
        { title: 'Fees', icon: 'mdi-currency-ngn', url: 'fees', cleared: true, mustBePermanent: false },
        { title: 'Wallet', icon: 'mdi-wallet', url: 'wallet', cleared: true, mustBePermanent: false },
        { title: 'Bio Data', icon: 'mdi-database', url: 'biodata', cleared: true,  mustBePermanent: false },
        { title: 'Other payment', icon: 'mdi-currency-ngn', url: 'other_fees', cleared: false, mustBePermanent: false },
        { title: 'My Courses', icon: 'mdi-book-open-page-variant', url: 'my-courses', cleared: true, mustBePermanent: true },
        { title: 'Course Registration', icon: 'mdi-alpha-c-circle', url: 'course-registration', cleared: true, mustBePermanent: true},
        { title: 'Time Table', icon: 'mdi-calendar-clock', url: 'time-table', cleared: true, mustBePermanent: true},
        { title: 'Results', icon: 'mdi-application-edit', url: 'results', cleared: true, mustBePermanent: true },
        { title: 'Accommodation', icon: 'mdi-home', url: 'accommodation', cleared: true, mustBePermanent: true },
        { title: 'Change Programme', icon: 'mdi-domain', url: 'programme', cleared: true, mustBePermanent: true },
        { title: 'My Documents', icon: 'mdi-file-multiple', url: 'student_document', cleared: true, mustBePermanent: true },
        { title: 'Notification', icon: 'mdi-bell', url: 'notification', cleared: true, mustBePermanent: true },
        { title: 'Clearance', icon: 'mdi-access-point', url: 'clearance', cleared: true, mustBePermanent: false }, //temp disabled
        // { title: 'Evaluations', icon: 'mdi-access-point', url: 'evaluation/evaluations', cleared: true, mustBePermanent: true },
        { title: 'Support', icon: 'mdi-help-circle', url: 'support', cleared: true, mustBePermanent: false },
    ],

    settings: [
        { title: 'Profile Settings', icon: 'mdi-shield-account', url: 'settings', cleared: false, mustBePermanent: false},
    ]
}

export default {
    OfficerLinks: OfficerLinks,
    StudentLinks: StudentLinks,
    officerRouteRoles: officerRouteRoles
};
